import { LatLng } from "./models/LatLng";

export const moveMapTo = (map: H.Map, latLng: LatLng, zoom: number) => {
    //console.log('moveMapTo: latLng: ', latLng, ' zoom: ', zoom);
    map.setCenter({lat:latLng.lat, lng: latLng.lng});
    map.setZoom(zoom);
}